import {removeContentSecurity} from "../../../floatTool/securityCheck";

/**
 * created by lei lei
 * //去除所有样式
 * 去除所有的div 标签换成p
 * 去除所有的a 标签
 * 去除所有的&nbsp
 */
const removeStyleAndPoint = (content)=>{
    if(!content){
        return content;
    }

    //去除所有样式
    // content=content.replace(/ style="[^"]*"/gi, '');
    //去除所有的div 标签换成p
    content=content.replace(/<div.*?>/g, "<p>").replace(/<\/div>/g, "</p>");
    //去除所有的a 标签
    content=content.replace(/<a.*?>|<\/a>/g, '');
    //去除所有的&nbsp
    content=content.replace(/(\s?&nbsp;\s?)*/g, '');
    content=content.replace(/<p>(\s?&nbsp;\s?)*<\/p>/g, "");
    content=content.replace(/<p class="vsbcontent_img">(\s?&nbsp;\s?)*<\/p>/g, "");
    //去除所有的&nbsp
    content=content.replace(/(<p>)<br><\/p>/g, '');
    content=content.replace(/(<p class="vsbcontent_img">)<br><\/p>/g, '');
    return content
};
export default removeStyleAndPoint;